import { createEffect } from 'effector';
import { stringify } from 'query-string';

import { apiFetch } from '@m/utils/http';

import type { SitePlatformSettings } from '@m/types/api';

export const updatePlatformSettings = createEffect({
  handler: ({ id, platformSettings }: { id: number; platformSettings: SitePlatformSettings }) =>
    apiFetch(`/admin/location/${id}/platform`, {
      method: 'PUT',
      body: platformSettings,
    }),
});

export const getEquipmentlessStatusFx = createEffect((params: { siteId: number }) =>
  apiFetch(`/admin/site/equipmentless-setting?${stringify(params)}`),
);

export const setEquipmentlessStatusFx = createEffect(
  (params: { enabled: boolean; siteId: number }) =>
    apiFetch(`/admin/site/enable-equipmentless?${stringify(params)}`, { method: 'POST' }),
);
